export default "__VITE_ASSET__4b01f89d__"